import React, { useState } from 'react';
import propTypes from 'prop-types';
import moment from 'moment';
import { Button, List, Row, Col } from 'antd';
import {
  DocumentPreviewModalDeprecated,
  resolveByUrl,
  Modal,
  Text,
} from '@common/components';
import { Colors } from 'works/legacy/lib/style-helper';

function askToArchiveSubmittalPacket(
  submittalPacketId,
  archiveSubmittalPacket
) {
  Modal.confirm({
    okText: 'Yes',
    title: 'Are you sure you want to archive this item?',
    content:
      "Note: your previous submissions using this submittal packet won't be affected.",
    onOk: () => {
      archiveSubmittalPacket({
        variables: {
          submittalPacketId,
        },
      });
    },
  });
}

function getLastFileFrom(submittalPacket) {
  return submittalPacket?.files[submittalPacket?.files?.length - 1];
}

export function RecentlyUploadedList({
  submittalPacket,
  archiveSubmittalPacket,
}) {
  const file = getLastFileFrom(submittalPacket);

  const [shouldShowPreviewModal, setShouldShowPreviewModal] = useState(false);
  const [filePathState, setFilePathState] = useState('');
  const [fileNameState, setFileNameState] = useState('');

  function openPreviewModal({ filePath, fileName }) {
    setFilePathState(filePath);
    setFileNameState(fileName);
    setShouldShowPreviewModal(true);
  }

  function previewModalClosed() {
    setFilePathState('');
    setFileNameState('');
    setShouldShowPreviewModal(false);
  }
  return (
    <>
      <DocumentPreviewModalDeprecated
        visible={shouldShowPreviewModal}
        assets={[filePathState]}
        resolveAsset={resolveByUrl}
        title={fileNameState}
        onCancel={previewModalClosed}
      />
      <List.Item
        key={submittalPacket.id}
        className={`submittal-packet-item ${
          submittalPacket.archived ? 'submittal-packet-item--archived' : ''
        }`}
        extra={
          <Col span={4} key="action">
            <Row justify="center">
              {!submittalPacket.archived ? (
                <Button
                  danger
                  onClick={() =>
                    askToArchiveSubmittalPacket(
                      submittalPacket.id,
                      archiveSubmittalPacket
                    )
                  }
                >
                  Archive
                </Button>
              ) : (
                <span>Archived</span>
              )}
            </Row>
          </Col>
        }
      >
        <Col>
          <div>
            <a
              onClick={() =>
                openPreviewModal({
                  filePath: file?.downloadUrl,
                  fileName: file?.filename,
                })
              }
            >
              <Text weight="bold" color="elm">
                {file?.filename}
              </Text>
            </a>
          </div>
          <div>
            <Text>
              Uploaded {moment(file?.createdAt).format('h:mmA, M/D/YYYY')}
            </Text>
          </div>
        </Col>
      </List.Item>
      <style jsx>{`
        :global(.submittal-packet-item--archived) {
          background-color: ${Colors.steelLightest};
        }
      `}</style>
    </>
  );
}

RecentlyUploadedList.propTypes = {
  submittalPacket: propTypes.shape({
    id: propTypes.string,
    archived: propTypes.bool,
    files: propTypes.arrayOf(
      propTypes.shape({
        filename: propTypes.string,
        downloadUrl: propTypes.string,
        createdAt: propTypes.string,
      })
    ),
  }),
  archiveSubmittalPacket: propTypes.func,
};
